function pad(num: number) {
  return ('00' + num).slice(-2)
}

function getHours(duration: number) {
  return Math.floor(duration / 60 / 60)
}

function getMinutes(duration: number) {
  return Math.floor(duration / 60) % 60
}

function getSeconds(duration: number) {
  return Math.floor(duration % 60)
}

export function formatDuration(duration: number) {
  if (duration <= 0) {
    return '0:00'
  }

  const hours = getHours(duration)
  const minutes = getMinutes(duration)
  const seconds = getSeconds(duration)

  const arr = [hours, minutes, seconds]

  // remove hours if 0
  if (arr[0] === 0) {
    // shift arr to the left [0,1,1] => [1,1]
    arr.shift()
  }

  const result = [arr[0].toString()]
  // pad all elements expect the first
  for (let i = 1; i < arr.length; i++) {
    result.push(pad(arr[i]))
  }
  return result.join(':')
}
